<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            @rowSelectionChanged="preview"
            download-filename="Wideband Closed Products"
            ajax-path="wideband/products"
            :ajax-params="ajaxParams"            
            :refresh.sync="refreshTable"
            :loading="tableIsLoading"
            :loading-text="tableLoadingText"
        />
        <app-modal 
            width="lg:w-2/3"
            bg="bg-gray-200"
            :show.sync="showPreviewModal"
            @close="showPreviewModal = false"
        >
            <template slot="header">PRODUCT DETAILS</template>
            <template slot="body">                
                <div class="card">
                    <table class="table">
                        <tr>
                            <td><strong>Wideband Service ID</strong></td>
                            <td>
                                <div>{{ product.id }}</div>
                            </td>
                            <td><strong>Your Reference</strong></td>
                            <td>
                                <div>{{ product.access_seeker_ref }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Status</strong></td>
                            <td>
                                <div>{{ product.status }}</div>
                            </td>
                            <td><strong>Created</strong></td>
                            <td>
                                <div>{{ product.created_at_for_human }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Access Technology</strong></td>
                            <td>
                                <div>{{ product.nbn_access_technology }}</div>
                            </td>
                            <td><strong>NBN Location ID</strong></td>
                            <td>
                                <div>{{ product.nbn_location_id }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Address</strong></td>
                            <td colspan="3">
                                <div>{{ product.formatted_address }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Bandwidth Profile</strong></td>
                            <td>
                                <div>{{ product.nbn_bandwidth_profile }}</div>
                            </td>
                            <td><strong>NBN CVC ID</strong></td>
                            <td>
                                <div>{{ product.nbn_cvc_id }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>NBN PRI ID</strong></td>
                            <td>
                                <div>{{ product.nbn_pri_id }}</div>
                            </td>
                            <td><strong>NBN AVC ID</strong></td>
                            <td>
                                <div>{{ product.nbn_avc_id }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>NBN C-Tag</strong></td>
                            <td>
                                <div>{{ product.nbn_ctag }}</div>
                            </td>
                            <td><strong>NBN UNI-D ID</strong></td>
                            <td>
                                <div>{{ product.nbn_unid_id }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>NBN NTD ID</strong></td>
                            <td>
                                <div>{{ product.nbn_ntd_id }}</div>
                            </td>
                            <td><strong>NBN NTD Port</strong></td>
                            <td>
                                <div>{{ product.nbn_ntd_port_id }}</div>
                            </td>
                        </tr>                    
                    </table>
                </div>
                <h2 class="mt-6 mb-3 font-thin tracking-widest uppercase flex-1">Order History</h2>
                <tabulator 
                    :data="product.order_history"
                    :columns="[
                        {
                            title: 'ID',
                            field: 'order_id',
                            width: 80,
                        },
                        {
                            title: 'Created',
                            field: 'created_at_for_human',
                            minWidth: 200,
                        },
                        {
                            title: 'Order Type',
                            field: 'order_type',
                            minWidth: 200,
                        },
                        {
                            title: 'Status',
                            field: 'status',
                            minWidth: 90,
                        }
                    ]"
                    :show-header="false"
                    :show-footer="false"
                />
            </template>
        </app-modal>        
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Form from '@/helpers/Form';

    export default {
        name: 'widebandClosedProducts',
        data() {
            return {
                ajaxParams: {type: 'closed'},
                showPreviewModal: false,
                tableIsLoading: false,
                tableLoadingText: null,                
                refreshTable: false,                
                columns: [
                    {
                        title: 'ID',
                        field: 'id',
                        sorter: 'string',
                        width: 90,
                    },
                    {
                        title: 'Created',
                        field: 'created_at_for_human',
                        sorter: 'string',
                        minWidth: 170,
                    },
                    {
                        title: 'Access Technology',
                        field: 'nbn_access_technology',
                        sorter: 'string',
                        minWidth: 170,
                    },
                    {
                        title: 'NBN Location ID',
                        field: 'nbn_location_id',
                        sorter: 'string',
                        minWidth: 170,
                    },
                    {
                        title: 'NBN AVC ID',
                        field: 'nbn_avc_id',
                        minWidth: 170,
                    },
                    {
                        title: 'Username',
                        field: 'access_seeker_ref',
                        sorter: 'string',
                        minWidth: 200,
                    }
                ],
                actions: [
                    {
                        label: 'Sync',
                        icon: () => import('@/icons/Sync.vue'),
                        handler: this.sync
                    }
                ],
            }
        },
        computed: {
            ...mapGetters({
                products: 'wideband/products/items',
                product: 'wideband/products/selected',
            })
        },
        methods: {            
            preview(products) {
                if (products.length) {
                    this.showPreviewModal = true;
                    this.$store.commit('wideband/products/setSelected', products[0]);
                }
            },
            sync() {
                this.tableIsLoading = true;
                this.tableLoadingText = 'Syncing...';
                this.$store.dispatch('wideband/products/sync', 'closed')
                    .then(() => {
                        this.tableIsLoading = false;
                        this.refreshTable = true;
                        this.$toast.fire({
                            type: 'success',
                            title: 'Syncing complete.'
                        });
                    })
                    .catch(() => {
                        this.tableIsLoading = false;
                    })
            }
        }
    }
</script>